// extracted by mini-css-extract-plugin
module.exports = {"overlay":"OpeningHours_overlay__6szYw","overlayDesktop":"OpeningHours_overlayDesktop__IkTeT"};